const inFlight = new Map<string, Promise<unknown>>();

/** Dedupe concurrent async work by stable string key. */
export function dedupeInFlight<T>(key: string, run: () => Promise<T>): Promise<T> {
  const pending = inFlight.get(key);
  if (pending) {
    return pending as Promise<T>;
  }

  const request = run().finally(() => {
    inFlight.delete(key);
  });
  inFlight.set(key, request);
  return request;
}

export function skuListCacheKey(skus: readonly string[]): string {
  return [...new Set(skus.map((sku) => sku.trim().toUpperCase()).filter(Boolean))].sort().join('|');
}
